export const OAUTH_TOKENS_KEY = 'oauth.tokens';

export const getStoredOAuthTokens = () => {
  try {
    const raw = localStorage.getItem(OAUTH_TOKENS_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const getAccessToken = () => getStoredOAuthTokens()?.access_token || null;

export const getRefreshToken = () => getStoredOAuthTokens()?.refresh_token || null;

export const setStoredOAuthTokens = (tokens) => {
  if (!tokens) {
    localStorage.removeItem(OAUTH_TOKENS_KEY);
    return;
  }

  try {
    localStorage.setItem(OAUTH_TOKENS_KEY, JSON.stringify(tokens));
  } catch {
    localStorage.removeItem(OAUTH_TOKENS_KEY);
  }
};

export const clearStoredOAuthTokens = () => {
  localStorage.removeItem(OAUTH_TOKENS_KEY);
};